import React from "react";
import { useDispatch, useSelector } from "react-redux";

import "./HeadlineBuilder.css";

import { selectWord } from "../../../redux/features/gameSlice";
import { toTileCase } from "../../../util/util";

const SLOT_LABELS = ["1st word", "2nd word", "3rd word"];

// Shows the headline being assembled from the selected tiles; tap a word to clear it.
const HeadlineBuilder = () => {
  const dispatch = useDispatch();
  const selectedNewsie = useSelector(
    (state: any) => state.gameReducer.selectedNewsie
  );
  const words = useSelector((state: any) => state.gameReducer.words)?.[
    selectedNewsie
  ];
  const selected = useSelector((state: any) => state.gameReducer.selectedWords);
  const incorrectGuess = useSelector(
    (state: any) => state.gameReducer.incorrectGuess
  );

  if (!words) return null;

  return (
    <div className={`headline-builder ${incorrectGuess ? "incorrect" : ""}`}>
      {words.map((column, i) => {
        const wordIndex = selected?.[i];
        const word = Number.isInteger(wordIndex) ? column[wordIndex] : null;
        return (
          <div
            key={i}
            className={`headline-builder-slot ${word ? "filled" : ""}`}
            onClick={() =>
              word &&
              dispatch(selectWord({ columnIndex: i, wordIndex: null, fromTap: true }))
            }
          >
            {word ? toTileCase(word) : SLOT_LABELS[i] || ""}
          </div>
        );
      })}
    </div>
  );
};

export default HeadlineBuilder;
